
import { Briefcase, User, Check, HeadphonesIcon } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { TimelineStep } from "./TimelineStep";
import { type RegistrationType, type RegistrationFlowType } from "@/hooks/use-registration-flow";

interface TimelineProps {
  selectedSegment: string | null;
  registrationType: RegistrationType;
  flowType: RegistrationFlowType;
}

export function Timeline({ selectedSegment, registrationType, flowType }: TimelineProps) {
  const steps = [
    {
      title: "Tipo de credenciamento",
      icon: <HeadphonesIcon className="w-5 h-5" />,
      isCompleted: !!flowType,
      isActive: !flowType,
    },
    {
      title: "Escolha seu segmento",
      icon: <Briefcase className="w-5 h-5" />,
      isCompleted: !!selectedSegment,
      isActive: !!flowType && !selectedSegment,
    },
    {
      title: "Tipo de cadastro",
      icon: <User className="w-5 h-5" />,
      isCompleted: !!registrationType,
      isActive: !!selectedSegment && !registrationType,
    },
    {
      title: "Finalizar cadastro",
      icon: <Check className="w-5 h-5" />,
      isCompleted: false,
      isActive: !!registrationType,
    },
  ];

  const progress = steps.filter((step) => step.isCompleted).length * 33;

  return (
    <div className="sticky top-0 bg-white z-10 pt-8 pb-6 px-4 shadow-sm rounded-lg mt-16 mb-12 animate-fade-in">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-start justify-between mb-4 relative">
          {steps.map((step, index) => (
            <TimelineStep key={index} {...step} />
          ))}
          <div className="absolute top-5 left-0 w-full -z-10">
            <Progress value={progress} className="h-1.5" />
          </div>
        </div>
      </div>
    </div>
  );
}
